// Ids must be byte-identical with glados (apps/glados/components/SideNav/navItemId.ts)
// or pins set in one client won't be addressable from the other. Inputs are the
// English source labels — slugging localized strings breaks parity across locales.

function slug(label) {
  return label
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/(^-|-$)/g, '');
}

export function navItemId(groupLabel, subSectionLabel, linkLabel) {
  return [groupLabel, subSectionLabel, linkLabel]
    .filter(part => Boolean(part))
    .map(slug)
    .join('/');
}
